<template>
    <el-main>
        <div class="control-bar">
            <span class="title">角色管理</span>
            <el-form :inline="true" size="small">
                <el-form-item v-if="admin.actions.indexOf('isadd') != -1">
                    <el-button type="primary" @click="addGroup">添加角色</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table :data="lists" border header-cell-class-name="table-header">
            <!-- <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="80"> -->
            <el-table-column label="GID" align="center" prop="gid" width="80">
            </el-table-column>
            <el-table-column prop="title" label="角色名称"> </el-table-column>
            <el-table-column prop="description" label="角色描述"> </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-edit" circle size="small"
                        v-if="admin.actions.indexOf('isedit') != -1"
                        @click="editGroup(scope.$index, scope.row)"></el-button>
                    <el-button type="danger" icon="el-icon-delete" circle size="small"
                        v-if="admin.actions.indexOf('isdel') != -1"
                        @click="delGroup(scope.$index, scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <p>
            <el-pagination background layout="sizes, prev, pager, next, total" :page-sizes="[10, 15, 20, 50, 100]"
                @size-change="handleSizeChange" @current-change="getLists" :current-page="page"
                :page-size="$store.state.offset" :total="totals">
            </el-pagination>
        </p>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
            <el-form v-model="groupForm" label-position="right" label-width="120px" label-suffix="：">
                <el-form-item label="角色名称">
                    <el-input v-model="groupForm.title" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item label="角色描述">
                    <el-input v-model="groupForm.description" placeholder="请输入角色描述" type="textarea" row="3"></el-input>
                </el-form-item>
                <el-form-item label="角色权限">
                    <el-tree :data="rights" show-checkbox default-expand-all check-on-click-node node-key="mid"
                        ref="tree" :props="rightsProps"></el-tree>
                </el-form-item>
                <el-form-item label="角色行为">
                    <el-checkbox-group v-model="groupForm.actions">
                        <el-checkbox label="isadd">添加</el-checkbox>
                        <el-checkbox label="isedit">修改</el-checkbox>
                        <el-checkbox label="isdel">删除</el-checkbox>
                        <el-checkbox label="ischeck">审核</el-checkbox>
                        <el-checkbox label="isimport">导入</el-checkbox>
                        <el-checkbox label="isexport">导出</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveGroup">确 定</el-button>
            </template>
        </el-dialog>
    </el-main>
</template>

<script>
    import {
        httpRequest,
        getCookie
    } from "@/utils/app";

    export default {
        data() {
            return {
                admin: {},
                page: 1,
                lists: [],
                totals: 0,
                dialogTitle: "添加角色",
                dialogVisible: false,
                groupForm: {
                    gid: 0,
                    title: "",
                    description: "",
                    rights: [],
                    actions: [],
                },
                rights: {},
                defaultRights: [],
                rightsProps: {
                    children: "child",
                    label: "name",
                },
            };
        },
        created() {
            this.admin = getCookie("admin");

            // 获取用户权限
            httpRequest({
                action: "adminMenu_category",
            }).then((response) => {
                if (response.error) {
                    this.$message({
                        type: "error",
                        message: response.msg,
                    });
                } else {
                    this.rights = response.data;
                }
            });

            this.getLists(1);
        },
        methods: {
            // 每页条数变更：写入 Vuex + localStorage（全局共享）后重新加载
            handleSizeChange(e) {
                this.$store.commit("setOffset", e);
                this.getLists(1);
            },
            // 获取列表
            getLists(page) {
                httpRequest({
                    action: "adminGroup_lists",
                    gid: this.admin.gid,
                    page: page,
                    offset: this.$store.state.offset,
                }).then((response) => {
                    if (response.error === false) {
                        this.page = page;
                        this.lists = response.data;
                        this.totals = parseInt(response.totals);
                    }
                });
            },
            addGroup() {
                this.groupForm = {
                    gid: 0,
                    title: "",
                    description: "",
                    rights: [],
                    actions: [],
                };
                this.dialogTitle = "添加角色";
                this.dialogVisible = true;
                setTimeout(() => {
                    this.$refs.tree.setCheckedKeys(this.groupForm.rights);
                }, 0);
            },
            editGroup(index, row) {
                this.dialogTitle = "编辑角色";
                this.groupForm = row;
                this.dialogVisible = true;

                // 解决子节点未全部选中，却全部显示的bug
                this.defaultRights = [];
                for (var i = 0; i < this.groupForm.rights.length; i++) {
                    var ischild = true;
                    for (var j = 0; j < this.rights.length; j++) {
                        if (this.groupForm.rights[i] === this.rights[j].mid) {
                            //父节点
                            if (!this.rights[j].child) {
                                //没有子节点
                                this.defaultRights.push(this.groupForm.rights[i]);
                            }
                            ischild = false;
                        }
                    }
                    if (ischild) {
                        this.defaultRights.push(this.groupForm.rights[i]);
                    }
                }
                setTimeout(() => {
                    this.$refs.tree.setCheckedKeys(this.defaultRights);
                }, 0);
            },
            //删除
            delGroup(index, row) {
                this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    httpRequest({
                        action: "adminGroup_delete",
                        gid: row.gid,
                    }).then((response) => {
                        if (response.error === false) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getLists(this.page);
                        }
                    });
                });
            },
            saveGroup() {
                let params = {};
                params.action = "adminGroup_add";
                params.gid = this.groupForm.gid;
                params.title = this.groupForm.title;
                params.description = this.groupForm.description;
                params.rights = encodeURI(
                    JSON.stringify(
                        this.$refs.tree
                        .getCheckedKeys()
                        .concat(this.$refs.tree.getHalfCheckedKeys())
                    )
                );
                params.actions = encodeURI(JSON.stringify(this.groupForm.actions));
                if (params.title.trim() === "") {
                    this.$message({
                        type: "error",
                        message: "角色名称不得为空",
                    });
                    return;
                }

                if (params.description.trim() === "") {
                    this.$message({
                        type: "error",
                        message: "角色描述不得为空",
                    });
                    return;
                }

                let that = this;
                httpRequest(params).then((response) => {
                    if (response.error) {
                        this.$message({
                            type: "error",
                            message: response.msg,
                        });
                        return;
                    }
                    that.dialogVisible = false;
                    // that.handleCurrentChange(that.page)
                    this.$message({
                        type: "success",
                        message: response.msg,
                        onClose: false,
                    });

                    this.getLists(this.page);
                });
            },
            // indexMethod(index) {
            //   return index + (this.page - 1) * this.offset + 1;
            // }
        },
    };
</script>
<style scoped>
    ::v-deep .el-tree .el-tree-node__children {
        display: flex;
        flex-flow: row wrap;
    }

    ::v-deep .el-tree .el-tree-node__children .el-tree-node {
        width: 120px;
    }
</style>